import React, { useCallback } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import colors from '../../../../constants/colors';
import { desktopMinWidth } from '../../../../../utils/windowHelpers';
import { LinkedinShareButton, TwitterShareButton } from 'react-share';
import TwitterIcon from '../../../../components/icons/TwitterIcon';
import LinkedInIcon from '../../../../components/icons/LinkedInIcon';
import { trackEvent } from '../../../../../utils/analytics';

const ShareVia = ({ tokenId, contractAddress, token }) => {
  const useStyles = makeStyles(theme =>
    createStyles({
      root: {
        margin: '32px 0',
      },
      socialIcons: {
        display: 'flex',
        alignItems: 'center',
      },
      socialIcon: {
        marginRight: 16,
      },
      label: {
        fontSize: 12,
        color: colors.gray_aa,
        marginBottom: 8,
        [desktopMinWidth]: {
          fontSize: 14,
        },
      },
    }),
  );

  const classes = useStyles();
  const { description, name } = token?.metadata || {};

  const trackClickEvent = useCallback(
    platformType => {
      const path = window.location.pathname + window.location.search;
      trackEvent('shareCert', 'Share Minted Cert', path, {
        tokenId,
        contractAddress,
        platformType,
      });
    },
    [tokenId, contractAddress],
  );

  const sharingLink = `${process.env.REACT_APP_FRONTEND_URL}/details/${contractAddress}/${tokenId}`;

  return (
    <div className={classes.root}>
      <div className={classes.label}>SHARE VIA</div>
      <div className={classes.socialIcons}>
        <div className={classes.socialIcon}>
          <TwitterShareButton
            url={`${process.env.REACT_APP_FRONTEND_URL}/details/${contractAddress}/${tokenId}`}
            via={''}
            title={name}
            hashtags={[]}
            related={[]}
            onClick={() => {
              trackClickEvent('twitter');
            }}
          >
            <TwitterIcon />
          </TwitterShareButton>
        </div>
        <div className={classes.socialIcon}>
          <LinkedinShareButton
            url={`${process.env.REACT_APP_OPENSEA_BASE_URL}/${contractAddress}/${tokenId}`}
            title={name}
            summary={description}
            onClick={() => {
              trackClickEvent('linkedin');
            }}
          >
            <LinkedInIcon />
          </LinkedinShareButton>
        </div>
      </div>
    </div>
  );
};

export default ShareVia;
